import React, { useState } from 'react';
import { useFetch } from '../../useFetch';
import homepageBffRepository from '../model/homepageBffRepository';
import reportError from '../../../client/tracking/errorReporter';
import NewsAndAds from './NewsAndAds';
import NewsAndAdsSkeleton from './NewsAndAdsSkeleton';
import { CHANNEL_PROP_TYPES } from '../../../shared/model/types';
import { withRelease } from '../../../shared/releaseContext';
import { FEATURE_FLAGS_PROP_TYPES } from '../../../shared/experiments/phasedRelease/config';

export const NewsAndAdsContainer = ({ currentChannel, featureFlags }) => {
  const [articlesCache, setArticlesCache] = useState({});
  const { articles } = articlesCache;

  const { error } = useFetch(
    () => (
      articles
        ? Promise.resolve(articles)
        : homepageBffRepository.getNews(featureFlags).then(setArticlesCache)
    ),
    e => reportError(e, 'Could not load news'),
    20000,
  );

  if (articles?.length && !error) {
    return <NewsAndAds
      articles={articles}
      currentChannel={currentChannel}
    />;
  }

  return error ? null : <NewsAndAdsSkeleton />;
};

NewsAndAdsContainer.propTypes = {
  currentChannel: CHANNEL_PROP_TYPES.isRequired,
  featureFlags: FEATURE_FLAGS_PROP_TYPES,
};

export default withRelease()(NewsAndAdsContainer);
